import { render, staticRenderFns } from "./ConsumptionPerformanceTable.vue?vue&type=template&id=5989ef51&"
import script from "./ConsumptionPerformanceTable.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionPerformanceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports